import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import ws from './module/websocket'
import container from './module/container'
import privateCloud from './module/private-cloud'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    ws,
    container,
    privateCloud
  }
})
